import { Component, OnInit, Input, OnChanges, ViewChild, ElementRef } from '@angular/core'
import { Form } from '@angular/forms'
import { ChatService } from './chat.service'
import { Observable, pipe } from 'rxjs'
import 'rxjs/add/operator/first'
import * as moment from 'moment'

@Component({
	selector: 'app-chat',
	templateUrl: './chat.component.html',
	styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
	@Input() file: any
	@ViewChild('container') container: ElementRef
	newmessage = null
	messages: any
	profile_pictures: any
	last_message: string

	constructor(
		public cs: ChatService,
	) {}

	ngOnInit() {
		this.profile_pictures = localStorage.getItem('profile_pictures') ? JSON.parse(localStorage.getItem('profile_pictures')) : new Object()
	}

	ngOnChanges() {
		if (this.file) {
			this.cs.getMessages(this.file).valueChanges().subscribe(messages => {
				let previous_message: any
				for (let i in messages) {
					let message: any = messages[i]

					// Profile picture
					if (!this.profile_pictures[message.user.uid]) {
						this.profile_pictures[message.user.uid] = this.cs.user.default_picture
						this.cs.user.getUserPicture(message.user.uid).subscribe(picture => {
							// if (picture) {
								this.profile_pictures[message.user.uid] = picture
								localStorage.setItem('profile_pictures', JSON.stringify(this.profile_pictures))
							// }
						})
					}

					messages[i]['hide_picture'] = (previous_message && previous_message.user && previous_message.user.uid == message.user.uid && previous_message.type == 'text') ? true : false

					if (messages[i]['type'] == 'update') {
						if (previous_message && previous_message['group_update']) {
							messages[i]['group_update'] = previous_message['group_update'] + 1
							previous_message['group_update'] = 0
						} else {
							messages[i]['group_update'] = 1
						}
					}

					// messages[i]['moment'] = moment(message.date).format('MMMM Do YYYY, h:mm:ss a')
					// messages[i]['moment'] = moment(message.date).calendar()
					messages[i]['moment'] = moment(message.date).format('lll')
					previous_message = message
				}
				this.messages = messages

				// AutoScroll if a new message has been added
				if (previous_message && this.last_message != previous_message.id) {
					this.last_message = previous_message.id
					this.container.nativeElement.scrollTo({
						top: this.container.nativeElement.scrollHeight,
						left: 0,
						behavior: 'smooth'
					})
					this.container.nativeElement.scrollTop = this.container.nativeElement.scrollHeight
					setTimeout(e => {
						this.container.nativeElement.scrollTop = this.container.nativeElement.scrollHeight
					}, 100)
				}
			})
		}
	}

	onChange(event) {
		event.stopPropagation()
	}

	// jumpLine(event) {
	// 	this.newmessage += '\r'
	// 	event.stopPropagation()
	// }

	sendMessage() {
		if (this.newmessage.trim().length < 1) return;
		this.cs.postMessage(this.file, this.newmessage.trim()).then(() => {
			this.newmessage = null
		}, e => console.error)
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/chat/chat.component.ts